<template>
  <div>
    <vx-card v-can="'view-staff-departments'" titleIcon="FilterIcon" ref="filterCard" title="Filters" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row">

        <!-- <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
           <label class="text-sm opacity-75">Bookings</label>
           <v-select :options="bookingTypeOptions" :clearable="true"  v-model="localfilters.type"
                     class="mb-4 md:mb-0"/>
         </div>-->
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Name</label>
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="filters['name']"  placeholder="Search..." />
        </div>

      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                     color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="DEPARTMENTS" v-can:any="['create-edit-staff-departments', 'view-staff-departments']">
          <template slot="actions">
            <!--          <vs-button  @click="popupActive=true"  class="ml-auto mt-3 mb-3  cursor-pointer btn-sm" color="primary" type="border" icon-pack="feather" icon="icon-plus"-->
            <!--          >Add User </vs-button>-->
            <vs-button v-can="'create-edit-staff-departments'" @click="createGroupPopUp" class="" color="primary" type="filled">Create Department</vs-button>

          </template>
          <div slot="no-body" class="mt-4">
            <vs-table v-can="'view-staff-departments'" :max-items="(meta.per_page) ? meta.per_page : 10" @sort="handleSort" :sst="true" :data="departments" stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th sort-key="name">NAME</vs-th>
                <vs-th>DESCRIPTION</vs-th>
                <vs-th v-can:any="['create-edit-staff-departments', 'view-staff-departments']">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description || 'N/A' }}
                  </vs-td>
                  <vs-td v-can:any="['create-edit-staff-departments', 'view-staff-departments']">
                    <div class="vx-row">
                      <vx-tooltip text="Edit" position="left" v-if="$can('create-edit-staff-departments')">
                        <!--                    <vs-button @click="popupActive=true"-->
                        <vs-button @click="onClickDepartmentEdit(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="View Log" position="left" class="ml-2">
                        <vs-button @click="onClickViewDepartmentLogs(data[indextr])"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-file-text"></vs-button>
                      </vx-tooltip>
<!--                      <vx-tooltip text="Delete" position="left" class="ml-3">-->
<!--                        &lt;!&ndash;                    <vs-button @click="popupActive=true"&ndash;&gt;-->
<!--                        <vs-button @click="openConfirm()"-->
<!--                                   radius color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>-->
<!--                      </vx-tooltip>-->
                    </div>
                  </vs-td>
                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page" class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
      <vs-popup class="vs-con-loading__container user-edit-popup"
                :title="popupTitle"
                :active.sync="popupActive"
                :buttons-hidden="true">
        <vx-card no-shadow>
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickUpdateDepartment(selectedDepartment.id))" autocomplete="off">
              <div class="vx-row mb-3">
                <div class="vx-col w-full md:mb-0">
                  <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                    <small class="label">Department</small>
                    <vs-input v-model="selectedDepartment.name"  name="name" class="w-full required" label=""/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full">
                  <small class="label">Department Description</small>
                  <vs-textarea v-model="selectedDepartment.description" height="100px"/>
                </div>
              </div>
              <!-- Save & Reset Button -->
              <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
                <vs-button @click="onClickResetDepartmentUpdateForm" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
              </div>
            </form>
          </ValidationObserver>
        </vx-card>
      </vs-popup>
      <vs-popup class="vs-con-loading__container user-edit-popup"
                :title="popupTitle"
                :active.sync="createDepartmentPopupActive"
                :buttons-hidden="true">
        <vx-card no-shadow>
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickCreateDepartment)" autocomplete="off">
              <div class="vx-row mb-3">
                <div class="vx-col w-full md:mb-0">
                  <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                    <small class="label">Department</small>
                    <vs-input v-model="createDepartmentForm.name"  required name="name" class="w-full required" label=""/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full">
                  <small class="label">Department Description</small>
                  <vs-textarea v-model="createDepartmentForm.description" height="100px"/>
                </div>
              </div>

              <!-- Save & Reset Button -->
              <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
                <vs-button @click="onClickResetDepartmentCreateForm" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
              </div>
            </form>
          </ValidationObserver>
        </vx-card>
      </vs-popup>

      <view-department-log-pop-up ref="viewDepartmentLogPopUp" />
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { VTree, VSelectTree}  from 'vue-tree-halower'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import ViewDepartmentLogPopUp from '@/components/popups/department/ViewDepartmentLogPopUp.vue'
const DepartmentsRepository = RepositoryFactory.get('departments')

export default {
  name: 'AllUsersList',
  data () {
    return {
      selected: [],
      options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
      popupActive: false,
      createDepartmentPopupActive: false,
      popupTitle: '',
      editActive: false,
      edit: null,
      editProp: {},
      checkBox1: false,
      activeConfirm: false,
      departments: [],
      selectedDepartment: {},
      createDepartmentForm: {},
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
    }
  },
  components: {
    'v-select': vSelect,
    ViewDepartmentLogPopUp
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
  async mounted () {
    this.$refs.filterCard.isContentCollapsed = true
    this.$refs.filterCard.maxHeight = '1.5rem'
  },
  methods: {
    async loadDepartments() {
      this.$vs.loading()
      try {
        const {data} = await DepartmentsRepository.get(this.page,this.filterQuery,10, this.sort)
        this.departments =  data.data
        this.meta =  data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async onClickDepartmentEdit (id) {
      this.$vs.loading()
      const {data} = await DepartmentsRepository.getDepartment(id)
      this.selectedDepartment = data.data
      this.$vs.loading.close()
      this.popupActive = true
      this.popupTitle = 'DEPARTMENT EDIT'

    },
    createGroupPopUp () {
      this.createDepartmentForm = {
        name: '',
        description: ''
      }
      this.createDepartmentPopupActive = true
      this.popupTitle = 'DEPARTMENT CREATE'
    },
    async onClickUpdateDepartment(departmentId) {
      this.$vs.loading()
      try {
        await DepartmentsRepository.updateDepartment(departmentId, {
          name: this.selectedDepartment.name,
          description: this.selectedDepartment.description
        })
        this.popupActive = false
        this.showSuccessMessage('The selected department was successfully updated')
        this.loadDepartments()
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },

    async onClickCreateDepartment() {
      this.$vs.loading()
     try {
       await DepartmentsRepository.createDepartment(this.createDepartmentForm)
       this.showSuccessMessage('New department created successfully')
       this.createDepartmentPopupActive = false
       this.loadDepartments()
     } catch (e) {
        this.convertAndNotifyError(e)
     }
      this.$vs.loading.close()
    },

    onClickViewDepartmentLogs(department) {
      this.$refs.viewDepartmentLogPopUp.openPopup(department.id, department.name)
    },

    filterQueryUpdate (){
      this.loadDepartments()
    },

    handleChangePage(page) {
      this.page=page;
      this.loadDepartments()
    },

    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.loadDepartments()
      }

    },
    onClickResetDepartmentUpdateForm() {
      this.selectedDepartment = {
        name: '',
        description: ''
      }
    },
    onClickResetDepartmentCreateForm() {
      this.createDepartmentForm = {
        name: '',
        description: ''
      }
    }

  },
  watch : {
    page(){
      this.loadDepartments()
    }
  }
}
</script>


<style lang="scss">
  @import "@/assets/scss/vuexy/extraComponents/tree.scss";

  button.btn-async{
    background: rgba(var(--vs-warning),0.15);
  }

  button.btn-delete{
    background: rgba(var(--vs-danger),0.15);
  }
</style>

